import { ReactNode } from 'react';
import { Box, Card, Flex, Text, SideNavigation } from '@scale/scaleui-radix';
import RedirectButtonLink from 'react-scale/corp/views/CorpProjectGroupManager/apps/Webinars/components/RedirectButtonLink';

export enum NavigationItems {
  WEBINAR_SETTINGS = 'Webinar settings',
  SESSION_SETTINGS = 'Sessions',
  SELECT_INVITEE = 'Select invitees',
}

export const NAVIGATION_ITEMS = [
  NavigationItems.WEBINAR_SETTINGS,
  NavigationItems.SESSION_SETTINGS,
  NavigationItems.SELECT_INVITEE,
];

interface WebinarFormLayoutProps {
  sectionIndex: number;
  setSectionIndex: (index: number) => void;
  webinarName: string | null;
  backUrl: string;
  backText: string;
  webinarSettingsContent: ReactNode;
  sessionSettingsContent: ReactNode;
  selectInviteeContent: ReactNode;
  inviteeSummaryContent: ReactNode;
  footerContent: ReactNode;
}

const WebinarFormLayout = ({
  sectionIndex,
  setSectionIndex,
  webinarName,
  backUrl,
  backText,
  webinarSettingsContent,
  sessionSettingsContent,
  selectInviteeContent,
  inviteeSummaryContent,
  footerContent,
}: WebinarFormLayoutProps) => {
  return (
    <Box p="8" className="h-full overflow-y-auto">
      <Flex direction="column" gap="4">
        <RedirectButtonLink destinationUrl={backUrl} text={backText} />

        <Text size="7" weight="medium">
          {webinarName || 'No webinar name yet'}
        </Text>

        <Flex gap="4">
          <Card className="h-fit w-[250px]">
            <SideNavigation.Root>
              <SideNavigation.Items>
                {NAVIGATION_ITEMS.map((title, index) => (
                  <SideNavigation.Item
                    active={sectionIndex === index}
                    onClick={() => setSectionIndex(index)}
                    key={title}
                  >
                    {title}
                  </SideNavigation.Item>
                ))}
              </SideNavigation.Items>
            </SideNavigation.Root>
          </Card>

          {NAVIGATION_ITEMS[sectionIndex] === NavigationItems.WEBINAR_SETTINGS && (
            <Card className="w-full min-h-fit max-h-[70vh] overflow-y-auto">
              <Box p="4">{webinarSettingsContent}</Box>
            </Card>
          )}

          {NAVIGATION_ITEMS[sectionIndex] === NavigationItems.SESSION_SETTINGS && (
            <Card className="w-full min-h-fit max-h-[70vh] overflow-y-auto">
              <Box p="4">{sessionSettingsContent}</Box>
            </Card>
          )}

          {NAVIGATION_ITEMS[sectionIndex] === NavigationItems.SELECT_INVITEE && (
            <Flex
              direction="column"
              gap="4"
              className="w-full min-h-fit max-h-[70vh] overflow-y-auto"
            >
              <Card className="w-full min-h-fit max-h-[70vh] overflow-y-auto">
                <Box p="4">
                  <Flex direction="column" gap="4">
                    {selectInviteeContent}
                  </Flex>
                </Box>
              </Card>
              {inviteeSummaryContent}
            </Flex>
          )}
        </Flex>

        {footerContent}
      </Flex>
    </Box>
  );
};

export default WebinarFormLayout;
